var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderCircleGradient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 0C10.4288 0 7.91543 0.762437 5.77759 2.19089C3.63975 3.61935 1.97351 5.64967 0.989572 8.02511C0.00563269 10.4006 -0.251811 13.0144 0.249797 15.5362C0.751405 18.0579 1.98953 20.3743 3.80762 22.1924C5.6257 24.0105 7.94208 25.2486 10.4638 25.7502C12.9856 26.2518 15.5994 25.9944 17.9749 25.0104C20.3503 24.0265 22.3806 22.3602 23.8091 20.2224C25.2376 18.0846 26 15.5712 26 13C26 11.2928 25.6637 9.60234 25.0104 8.02511C24.3571 6.44788 23.3995 5.01477 22.1924 3.80761C20.9852 2.60045 19.5521 1.64288 17.9749 0.989566C16.3977 0.336255 14.7072 0 13 0ZM13 2.6C13.7834 2.60512 14.5637 2.69667 15.327 2.873C15.101 3.38311 14.7527 3.82962 14.313 4.173C14.027 4.394 13.715 4.576 13.403 4.771C12.4153 5.2573 11.5825 6.00905 10.998 6.942C10.3577 8.27654 10.0797 9.75605 10.192 11.232C10.192 13 10.192 14.04 8.957 14.963C7.176 16.354 4.459 15.574 2.76901 14.872C2.65852 14.2541 2.60198 13.6277 2.60001 13C2.60001 10.2417 3.69572 7.59647 5.64609 5.64609C7.59647 3.69571 10.2418 2.6 13 2.6ZM3.90001 17.94C4.74946 18.1608 5.6224 18.2787 6.5 18.291C7.96848 18.3314 9.40734 17.8732 10.582 16.991C12.805 15.249 12.805 13.013 12.805 11.219C12.7064 10.1807 12.8719 9.13426 13.286 8.177C13.6622 7.66469 14.1635 7.25739 14.742 6.994C15.1553 6.75246 15.5546 6.48771 15.938 6.201C16.7459 5.56286 17.3732 4.72491 17.758 3.77C19.587 4.70582 21.0979 6.16241 22.1 7.956C20.241 8.216 17.602 8.827 17.082 11.245C16.9646 11.8227 16.9037 12.4105 16.9 13C16.9421 13.6589 16.8122 14.3174 16.523 14.911L16.393 15.132C15.548 16.536 14.599 18.135 15.886 20.332C16.042 20.605 16.211 20.865 16.38 21.125C16.726 21.5247 16.9593 22.0093 17.056 22.529C15.7774 23.0926 14.3972 23.389 13 23.4C11.1327 23.3907 9.30238 22.8788 7.70117 21.918C6.09996 20.9573 4.78696 19.5832 3.90001 17.94ZM19.409 21.216C19.1841 20.6969 18.9099 20.2006 18.59 19.734C18.447 19.526 18.304 19.318 18.174 19.097C17.667 18.213 17.849 17.797 18.668 16.497L18.798 16.276C19.3075 15.3037 19.5497 14.2136 19.5 13.117C19.4987 12.681 19.5379 12.2458 19.617 11.817C19.825 10.868 21.84 10.608 23.088 10.517C23.5924 12.4781 23.5088 14.5442 22.8477 16.4581C22.1867 18.3721 20.9772 20.0493 19.37 21.281L19.409 21.216Z",
    fill: "url(#paint0_linear_4000_32721)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4000_32721",
    x1: 1.71914,
    y1: 28.7953,
    x2: 30.7228,
    y2: 17.8529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderCircleGradient);
export default __webpack_public_path__ + "static/media/header-circle-gradient.4e286d144cae9ab64529c4b5fe91b803.svg";
export { ForwardRef as ReactComponent };